import { Button } from '@alifd/next';
import { createElement } from 'react';
const CustomFooter = (props) => {
    const { onOk, onCancel, left } = props;
    return (createElement("div", { className: 'customd_footer' },
        createElement("div", null, left),
        createElement("div", null,
            createElement(Button, { className: 'dialog_btn', type: "normal", onClick: onCancel }, "\u53D6\u6D88"),
            createElement(Button, { className: 'dialog_btn submit_btn', style: { marginLeft: '8px' }, type: "primary", onClick: onOk }, "\u786E\u5B9A"))));
};
export default CustomFooter;
